import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { CatalogTundishShroudReducer } from "./CatalogTundishShroudReducer";

const CatalogTundishShroudContext = createContext({
  state: CatalogTundishShroudReducer.getInitialState(),
  actions: CatalogTundishShroudReducer.actions,
});

export const useCatalogTundishShroudContext = () =>
  useContext(CatalogTundishShroudContext);

export const CatalogTundishShroudProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [state, actions] = useComplexState({
    initialState: CatalogTundishShroudReducer.getInitialState(),
    reducers: CatalogTundishShroudReducer.caseReducers,
  });
  return (
    <CatalogTundishShroudContext.Provider value={{ state, actions }}>
      {children}
    </CatalogTundishShroudContext.Provider>
  );
};
